import type { Catalog } from '..'

export const common: Catalog['common'] = {
  cancel: 'Cancelar',
  save: 'Salvar',
  delete: 'Excluir',
  close: 'Fechar',
  copy: 'Copiar',
  copied: 'Copiado',
  back: 'Voltar',
  loading: 'Carregando…',
  retry: 'Tentar de novo',
  justNow: 'agora mesmo',
  secondsAgo: 'há {count}s',
  minutesAgo: 'há {count} min',
  hoursAgo: 'há {count} h',
  daysAgo: 'há {count} d',
}
